/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ErrorCodeResponse } from '../../models/error-code-response';

export interface MetaErrorCodes$Json$Params {
}

export function metaErrorCodes$Json(http: HttpClient, rootUrl: string, params?: MetaErrorCodes$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ErrorCodeResponse>>> {
  const rb = new RequestBuilder(rootUrl, metaErrorCodes$Json.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ErrorCodeResponse>>;
    })
  );
}

metaErrorCodes$Json.PATH = '/api/v1/platform/meta/error-codes';
